<script lang="ts" setup>
import { nodeViewProps } from "@tiptap/vue-3";
import type { FieldDefinition } from "~/models/Automation";

const props = defineProps(nodeViewProps);

const item = computed<FieldDefinition>(() =>
    props.extension.options.getMatch(props.node),
);
</script>

<template>
    <TiptapNodeViewWrapper
        :data-key="item?.key"
        :data-label="item?.label"
        as="span"
    >
        <span
            class="inline-flex text-gray-900 items-center align-middle bg-white truncate max-w-full"
            v-if="item"
            v-bind="extension.options.HTMLAttributes"
        >
            <FontAwesomeIcon
                v-if="item.icon"
                :icon="item.icon"
                aria-hidden="true"
                class="my-0.5 mr-1"
                size="sm"
            />
            <UIAvatar
                v-else-if="item.avatar"
                aria-hidden="true"
                class="my-0.5 mr-1"
                v-bind="{ size: '3xs', ...item.avatar }"
            />
            <span
                v-else-if="item.chip"
                :style="{ background: `#${item.chip}` }"
            />
            <span class="truncate text-xs">{{ item.label }}</span>
        </span>
        <template v-else>
            {{
                node.attrs.key
                    ? makeVariable(node.attrs.key.toString())
                    : makeVariable("undefined")
            }}
        </template>
    </TiptapNodeViewWrapper>
</template>
